import { useAuth } from "@/hooks/use-auth";
import WriteStudio from "@/writer/WriteStudio";

export default function StoryStudio() {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Please log in to access StoryLikho</h1>
          <p className="text-muted-foreground">You need to be authenticated to create and manage your stories.</p>
        </div>
      </div>
    );
  }

  // WriteStudio is rendered without props here; props are injected by the parent routing layer
  return <WriteStudio {...({} as any)} />;
}